import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import FocusGrow from "../FocusGrow"
import parse from "html-react-parser"
import PubSub from "pubsub-js"

const sizeToClasses = {
  big: "h-[404px] md:h-[543px]",
  medium: "h-[314px] md:h-[424px]",
  small: "h-[202px] md:h-[272px]",
  tiny: "h-[115px] md:h-[154px]",
}

const positions = {
  right: "absolute top-10 right-16",
  center: "absolute top-20 left-1/2 transform -translate-x-1/2",
  big_center: "absolute top-[120px] left-1/2 transform -translate-x-1/2",
}

const renderTinyCard = (card, idx) => {
  const heightClass = sizeToClasses.tiny
  return (
    <Button
      key={idx}
      onClick={() => PubSub.publish("open-contacts-partners")}
      variant="card_button"
      className={heightClass}
    >
      <Typography
        variant="subtitle_32_accent"
        className="text-primary text-left !text-[24px] md:!text-[26px] lg:!text-[28px] xl:!text-[32px] group-hover:text-white p-0 m-0"
      >
        {card.title}
      </Typography>

      <Typography
        variant="info_16"
        className="text-text text-left group-hover:text-white m-0"
      >
        {parse(card.description.replace(/\n/g, "<br />"))}
      </Typography>
    </Button>
  )
}

const renderCard = (card, idx) => {
  const [size] = Array.isArray(card.size) ? card.size : [card.size]

  //render tiny cards differently
  if (size === "tiny") return renderTinyCard(card, idx)

  const [icon_location] = Array.isArray(card.icon_location)
    ? card.icon_location
    : [card.icon_location] || ["center"]
    
  const heightClass = sizeToClasses[size] || sizeToClasses.small
  const imageSize = "104px"
  let positionClass = positions[icon_location] || positions.center
  //big cards have a different position
  if (size === "big") {
    positionClass = positions.big_center
  }
  return (
    <div
      key={idx}
      className={`relative w-full ${heightClass} flex flex-col justify-between bg-theme_white px-5 md:px-10 pb-2 md:pb-6 pt-8 rounded-[24px] overflow-hidden shadow-custom_card`}
    >
      <FocusGrow
        radiusMultiplier={1.3}
        growClass={"bg-primary_lt z-0"}
        className={positionClass}
      >
        <img
          src={card.icon}
          alt={card.title}
          className={`relative z-10 h-auto object-cover mx-auto`}
          width={imageSize}
        />
      </FocusGrow>

      <div className="relative flex-1 flex flex-col justify-end z-10">
        <Typography
          variant="body_24_accent"
          className="!text-[18px] lg:!text-[20px] xl:!text-[24px] text-text my-0"
        >
          {card.title}
        </Typography>

        <Typography
          variant="info_16"
          className="text-text"
        >
          {card.description ? parse(card.description.replace(/\n/g, "<br />")) : ''}
        </Typography>
      </div>
    </div>
  )
}

const Column = ({ children }) => (
  <div className="flex flex-col gap-8 md:gap-12 w-full">{children}</div>
)

const distributeCardsToColumns = (cards, gridCols) => {
  // Initialize array of columns based on gridCols
  const columns = Array.from({ length: gridCols }, () => [])

  if (!Array.isArray(cards)) return []

  // Distribute cards to columns
  cards.forEach((card, idx) => {
    columns[idx % gridCols].push(card)
  })

  return columns
}

function CustomMadeVersions({ grid_cols = 2 }) {
  return (
    <CMSRender
      contentType="AquaSiteCardGroup"
      match={{ "content.id": "custom-made-versions" }}
      renderItem={(section) => {
        const columns = distributeCardsToColumns(section.cards, grid_cols)

        return (
          <div className="w-full px-4 md:px-[56px] xl:px-[76px] mb-16 md:mb-20 lg:mb-40">
            <Typography
              component="h2"
              variant="h1"
              className="text-center max-w-[500px] md:max-w-[800px] lg:max-w-full mb-[66px] mx-auto"
            >
              {section.title}
            </Typography>

            <div className="w-full max-w-[500px] md:max-w-[800px] lg:max-w-[900px] xl:max-w-[976px] mx-auto">
              <div className="flex flex-col md:flex-row gap-8 md:gap-12">
                {columns.map((columnCards, colIdx) => (
                  <Column key={colIdx}>{columnCards.map(renderCard)}</Column>
                ))}
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}

const AldooComponent = {
  id: 'CustomMadeVersions',
  component: CustomMadeVersions,
  input: {},
  meta: {
    name: 'Custom Made Versions',
    description: 'Multi-column card layout for custom version offerings',
    category: 'Marketing',
  },
}

export { AldooComponent }
export default CustomMadeVersions
